import Vue from 'vue'
import Router from 'vue-router'

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //     path: '/',
    //     name: 'index',
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     },
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/index.vue')), 'index')
    //   },
      {
        path: '/confirmEmail',
        name: 'confirmEmail',
        component: resolve => require.ensure([], () => resolve(require('@/pages/confirmEmail.vue')), 'confirmEmail'),
        meta: {
          title: "Speediance | The World's Most Comprehensive Home Gym"
        }
      },
      {
        path: '/callback',
        name: 'callback',
        component: resolve => require.ensure([], () => resolve(require('@/pages/callback.vue')), 'callback'),
        meta: {
          title: "Speediance | The World's Most Comprehensive Home Gym"
        }
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: resolve => require.ensure([], () => resolve(require('@/pages/resetPassword.vue')), 'resetPassword'),
        meta: {
          title: "Speediance | The World's Most Comprehensive Home Gym"
        }
      },
    //   {
    //     path: '/aboutUs',
    //     name: 'aboutUs',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/aboutUs.vue')), 'aboutUs'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/shopping',
    //     name: 'shopping',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/shopping.vue')), 'shopping'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/address',
    //     name: 'address',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/address.vue')), 'address'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/success',
    //     name: 'success',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/success.vue')), 'success'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/cart',
    //     name: 'cart',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/cart.vue')), 'cart'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/paypal',
    //     name: 'paypal',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/paypal.vue')), 'paypal'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/confirm',
    //     name: 'confirm',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/confirm.vue')), 'confirm'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/register',
    //     name: 'register',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/register.vue')), 'register'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/login',
    //     name: 'login',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/login.vue')), 'login'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/verifyEmail',
    //     name: 'verifyEmail',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/verifyEmail.vue')), 'verifyEmail'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/myOrder',
    //     name: 'myOrder',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/myOrder.vue')), 'myOrder'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/faq',
    //     name: 'faq',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/faq.vue')), 'faq'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/become-a-speediance-dealer',
    //     name: 'become-a-speediance-dealer',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/agent.vue')), 'agent'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/become-a-speediance-dealer-success',
    //     name: 'become-a-speediance-dealer-success',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/agentSuccess.vue')), 'agentSuccess'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/shareAsale',
    //     name: 'shareAsale',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/shareAsale.vue')), 'shareAsale'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/blog',
    //     name: 'blog',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/blog.vue')), 'blog'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/blogDetail',
    //     name: 'blogDetail',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/blogDetail.vue')), 'blogDetail'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
      {
        path: '/td',
        name: 'td',
        component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/td.vue')), 'td'),
        meta: {
          title: "Speediance | The World's Most Comprehensive Home Gym"
        }
      },
    //   {
    //     path: '/downloadApp',
    //     name: 'downloadApp',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/downloadApp.vue')), 'downloadApp'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/forgetPwd',
    //     name: 'forgetPwd',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/forgetPwd.vue')), 'forgetPwd'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   },
    //   {
    //     path: '/service',
    //     name: 'service',
    //     component: resolve => require.ensure([], () => resolve(require('@/pages/overseas/service.vue')), 'service'),
    //     meta: {
    //       title: "Speediance | The World's Most Comprehensive Home Gym"
    //     }
    //   }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title;
  next()
})

// 单页面ga分析
router.afterEach((to, from, next) => { 
  if(window.gtag){
    let id = (process.env.NODE_ENV =='production' || process.env.NODE_ENV == 'prodEn') ? 'G-MGNLE8T916' : 'G-CX0MXEQTYX'
    window.gtag('config', id, {'page_path': to.fullPath});
  }
 
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js